import { render, staticRenderFns } from "./ListInventoryQuotas.vue?vue&type=template&id=8919c408&scoped=true"
import script from "./ListInventoryQuotas.vue?vue&type=script&lang=js"
export * from "./ListInventoryQuotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8919c408",
  null
  
)

export default component.exports